export type PopoverPos = { left: number; top?: number; bottom?: number };

export interface PopoverSize {
  width: number;
  height: number;
  // Which anchor edge the popover lines up with.
  align?: 'left' | 'right';
}

// Fixed to the viewport so a scrolling wrapper (overflow: auto) cannot clip it;
// clamped to the viewport and opened upward when there is no room below. When
// neither side fits, it takes the roomier side and its top never goes above the
// viewport's 8px margin.
export const popover_position = (
  anchor: HTMLElement,
  { width, height, align = 'right' }: PopoverSize
): PopoverPos => {
  const r = anchor.getBoundingClientRect();
  const preferred = align === 'right' ? r.right - width : r.left;
  const left = Math.max(8, Math.min(Math.max(8, preferred), window.innerWidth - width - 8));
  const roomBelow = window.innerHeight - r.bottom;
  if (roomBelow >= height) return { top: r.bottom + 4, left };
  if (r.top - 4 - height >= 8) {
    return { bottom: window.innerHeight - r.top + 4, left };
  }
  if (r.top > roomBelow) return { top: 8, left };
  return { top: r.bottom + 4, left };
};
